<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="4">
        <v-select
          :items="apps"
          v-model="params.app"
          label="App"
          solo
        ></v-select>
      </v-col>
      <v-col cols="12" sm="4">
        <v-select
          :items="motions"
          v-model="params.motion"
          label="Motion"
          solo
        ></v-select>
      </v-col>
      <v-col cols="12" sm="4">
        <v-select
          :items="types"
          v-model="params.type"
          label="Type"
          solo
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6">
        <v-date-picker
          v-show="showCalendar"
          @change="showCalendar = false"
          v-model="params.dates"
          range
        ></v-date-picker>
      </v-col>
      <v-col cols="12" sm="5">
        <v-text-field
          v-model="dateRangeText"
          label="Date range"
          prepend-icon="fa-calendar"
          readonly
          @click="showCalendar = true"
        ></v-text-field>
      </v-col>
      <v-col col="12" sm="1">
        <v-btn color="primary" fab large dark @click="getItems">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h1 v-if="loading">Loading...</h1>
        <v-simple-table v-else>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">App</th>
                <th class="text-left">Motion</th>
                <th class="text-left">Date</th>
                <th class="text-left">Creative</th>
                <th class="text-left">
                  Type
                  <strong>(total {{ items.length }})</strong>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in items" :key="i">
                <td class="text-left">{{ item.app }}</td>
                <td class="text-left">{{ item.motion }}</td>
                <td class="text-left">{{ item.date }}</td>
                <td class="text-left">{{ item.creative }}</td>
                <td class="text-left">{{ item.type }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import { subMonths, format } from "date-fns";
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";

// import { debounceFn } from "../../../utils/debounceDec";

@Component
export default class Motion extends Vue {
  baseUrl = "https://er5sqiby16.execute-api.us-east-1.amazonaws.com";

  loading = false;
  items = [];
  types = [{ text: "No selected", value: null }, "new", "mod", "ref", "pic"];
  apps = [
    { text: "No selected", value: null },
    "Cleaner",
    "Scanner",
    "Sudoku",
    "Translator"
  ];
  motions = [
    { text: "No selected", value: null },
    "Dima",
    "Julia",
    "Max",
    "Nataly",
    "Vadym"
  ];

  showCalendar = false;

  params = {
    type: null,
    app: null,
    motion: null,
    dates: [
      format(subMonths(new Date(), 1), "YYYY-MM-DD"),
      format(new Date(), "YYYY-MM-DD")
    ]
  };

  created() {
    this.getItems();
  }

  @Watch("params", { deep: true })
  getItems() {
    this.loading = true;
    const {
      dates: [from, to],
      ...params
    } = this.params;
    const query = Object.entries({ ...params, from, to }).reduce(
      (acc, [key, value]) => (value ? (acc += `&${key}=${value}`) : acc),
      ""
    );

    fetch(`${this.baseUrl}/prod/motion?${query}`)
      .then(response => response.json())
      .then(items => {
        this.items = items;
        this.loading = false;
      });
  }

  get dateRangeText() {
    return this.params.dates.join(" ~ ");
  }
}
</script>
